
const m = window.require("embercom/models/data/stats-system/stats-constants");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
